import { applyMiddleware, createStore as reduxCreateStore } from "redux";
import { load, save } from "redux-localstorage-simple";
import reducer, { globReducer } from "@/store/reducer";

const createStoreWithMiddleware = applyMiddleware(
  save({
    namespace: "shiseido-seeubb",
  })
)(reduxCreateStore);

const store = createStoreWithMiddleware(
  reducer,
  load({
    namespace: "shiseido-seeubb",
  })
);

const createGlobWithMiddleware = applyMiddleware()(reduxCreateStore);

// export default createStoreWithMiddleWares;
export default store;

export const globFunc = createGlobWithMiddleware(globReducer);
